import customUriParser from './uriParser.js';

import {
  onVehicleSelected as cartVerifyOnVehicleSelected,
  onVehicleDiscarded as cartVerifyOnVehicleDiscarded,
  AfterInit as cartVerifyAfterInit,
} from './cartPageVerifyFitment.js';

const baseFitmentFields = ['Year', 'Make', 'Model'];
const extraFitmentFields = [
  'RoofHeight',
  'BedLength',
  'BodyLength',
  'BodyType',
  'FuelType',
  'RearWheels',
  'Wheelbase',
];
const wheelsFields = ['wheel_diameter', 'wheel_width', 'wheel_bolt_pattern'];
const tiresFields = ['tire_width', 'tire_height', 'tire_rim'];
const ignoreFields = [...wheelsFields, ...tiresFields];

const categorySelectionPageUrl = '/product-category/';
const brandSelectionPageUrl = '/brands/';

const isCategoryPage =
  window.location.pathname.includes('/product-category/') &&
  window.location.pathname !== categorySelectionPageUrl;

function getLocalPreselection(pageType) {
  if (pageType === 'category') {
    return [
      {
        field: 'categories',
        term: window.cm_category,
        treeLevel: window.cm_category.split('>').length - 1,
      },
    ];
  }
}

const onVehicleDiscarded = () => {
  cartVerifyOnVehicleDiscarded();
};

const AfterInit = () => {
  cartVerifyAfterInit();
};

export default {
  platform: 'woocommerce',
  searchPageUrl: '/shop/',
  AfterInit,
  getLocalPreselection,
  customUriParser,
  page: {
    getPageType(defaults) {
      return isCategoryPage ? 'category' : defaults.getter();
    },
  },
  SearchRequestDefaults: {
    pageSize: 36,
  },
  autocomplete: {
    requestDefaults: { extra: { isAutocompleteRequest: true } },
  },
  product: {
    noImageSrc: '/wp-content/uploads/woocommerce-placeholder-1000x1000.png',
  },
  facets: {
    rangedFacet: [{ fields: ['wheel_bore'], step: '1/10//1', slider: { mode: 'LowerBound' } }],
  },
  fitmentSearch: {
    baseFields: baseFitmentFields,
    extraFields: extraFitmentFields,
    onVehicleSelected: cartVerifyOnVehicleSelected,
    onVehicleDiscarded,
    categorySelectionPages: [
      { pathname: categorySelectionPageUrl, field: 'categories' },
      { pathname: brandSelectionPageUrl, field: 'brand' },
    ],
  },
  Widgets: [
    {
      name: 'SearchPage',
      location: 'body.woocommerce-shop #page .container .container',
      template: 'SearchPage',
    },
    {
      name: 'CategoryPage',
      type: 'SearchPage',
      location: {
        insertBefore: '#page .container .container',
        class: 'container cm_SearchPage__category',
      },
      template: 'SearchPage',
      visibleIf: () => isCategoryPage,
    },
    {
      name: 'CategoryFacetTiles',
      type: 'FacetPanel',
      visibleIf: () => isCategoryPage,
      disableCollapse: true,
      fields: ['categories'],
      showAllAlways: true,
    },
    {
      name: 'SearchHeader',
      sortSelectClass: 'form-select form-select--small',
      sortEntries: {
        'relevance': 'Best Match',
        'name': 'A to Z',
        'name:desc': 'Z to A',
        'price': 'Price: Ascending',
        'price:desc': 'Price: Descending',
      },
    },
    {
      name: 'SearchResult',
    },
    {
      name: 'SearchBoxDialogButton',
      location: {
        selector: '#siteheader .search',
        class: 'cm-desktop-search-box search',
      },
      template: 'searchBox/dialogButtonAdaptable',
    },
    {
      name: 'FilterChips',
      type: 'FacetPanel',
      ignoreFields: [...ignoreFields, 'categories'],
    },
    {
      name: 'Facets',
      type: 'FacetPanel',
      ignoreFields: [...ignoreFields, 'categories'],
    },
    {
      name: 'CategoryFacet',
      type: 'FacetPanel',
      fields: ['categories'],
      showAllAlways: true,
    },
    {
      name: 'FacetCategoryTiles',
      type: 'FacetTiles',
      location: '#cm-category-list',
      template: 'facetTiles/hierarchicalContainer',
      isMultiLevel: true,
    },
    {
      name: 'FacetBrandsTiles',
      type: 'FacetTiles',
      location: {
        replace: '.page-template-brands #page .brand-list',
        class: 'cm_vehicle-categories__brands',
      },
      template: 'facetTiles/hierarchicalContainer',
    },
    {
      name: 'HomeVehicleWidget',
      type: 'VehicleWidget',
      location: {
        insertAfter: '.tf-home-page-content .container.hero',
        class: 'container',
      },
      template: 'fitmentSearch/homeVehicleWidget',
      columnBreakpoint: 750,
    },
    {
      name: 'SearchVehicleWidget',
      type: 'VehicleWidget',
      isAlwaysActive: true,
    },
    {
      name: 'HeaderVehicleWidget_cart',
      type: 'VehicleWidget',
      location: {
        replace: '.woocommerce-cart .ufs-fitment-verify-wrap',
        class: 'ufs-fitment-cart-verify-wrap cm_vehicle-widget__cart',
      },
      template: 'fitmentSearch/cartVehicleWidget',
      isAlwaysActive: false,
      isAutoVehicleSelectionDisabled: true,
      doNotRedirectOnVehicleSelect: true,
    },
    {
      name: 'VerifyFitment',
      location: {
        replace: '.product-template-default .ufs-fitment-verify-wrap',
        class: 'cm_vehicle-widget__verify-fitment-container',
      },
      template: 'fitmentSearch/collapsibleVerifyFitment',
      initCollapsed: true,
      isAlwaysColumnLayout: true,
    },
    {
      name: 'FitmentTable',
      location: { replace: '.ufs-tab--ufs_fitment_tab .table-responsive' },
      template: 'fitmentSearch/fitmentTable',
    },
    {
      name: 'Garage',
      location: {
        insertBefore: '#siteheader .mini-cart',
        class: 'cm_garage__container',
      },
      template: 'fitmentSearch/garage',
    },
    {
      name: 'FacetDialog',
      template: 'FacetDialog',
    },
    {
      name: 'SearchBoxDialog',
      template: 'SearchBoxDialog',
    },
    {
      name: 'VehicleWidgetDialog',
      template: 'fitmentSearch/dialog',
    },
  ],
};
